import { Button, Input, InputNumber, Select, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { TEXT_DEF } from "../../../constant/text";
import { DAYS_WEEK } from "../../../constant/generate";
import "./style.css";
import { FiPlusCircle, FiMinusCircle } from "react-icons/fi";
import API, { COMMON } from "../../../network/api";
import ModalCommon from "../../../components/Modal";

const TicketTow = ({
  maintenanceTicket,
  onHandleChangeMode,
  setMaintenaceTicket,
  onShowModal,
}) => {
  const [day, setDay] = useState("1");
  const [dataMonday, setDataMonday] = useState();
  const [dataTuesday, setDataTuesday] = useState();
  const [dataWednesMonday, setDataWednesday] = useState();
  const [dataThursday, setDataThursday] = useState();
  const [dataFriday, setDataFriday] = useState();
  const [dataSaturday, setDataSaturday] = useState();
  const [dataSunday, setDataSunday] = useState();
  const [pointMoney2, setPointMoney2] = useState([]);
  const [roundArray2, setRoundArray2] = useState([]);
  const [coins, setCoins] = useState([]);
  const [coinLocal, setCoinLocal] = useState("");

  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    getDataTicket2();
  }, []);

  // lấy data của các thứ trong tuần
  const getDataTicket2 = async () => {
    try {
      const res = await API.get(
        `${COMMON}/all?take=100000000000&skip=1&order=ASC&keyword=%7B%22module%22%3A%20%22TICKET2%22%7D`
      );
      const data = res.data.data.result[0];

      if (res.data.data.code && data) {
        setDataMonday(
          data
            ? data.filter((el) => el.item === "1" && el.itemCode === "TITLE")
            : []
        );
        setDataTuesday(
          data
            ? data.filter((el) => el.item === "2" && el.itemCode === "TITLE")
            : []
        );
        setDataWednesday(
          data
            ? data.filter((el) => el.item === "3" && el.itemCode === "TITLE")
            : []
        );
        setDataThursday(
          data
            ? data.filter((el) => el.item === "4" && el.itemCode === "TITLE")
            : []
        );
        setDataFriday(
          data
            ? data.filter((el) => el.item === "5" && el.itemCode === "TITLE")
            : []
        );
        setDataSaturday(
          data
            ? data.filter((el) => el.item === "6" && el.itemCode === "TITLE")
            : []
        );
        setDataSunday(
          data
            ? data.filter((el) => el.item === "0" && el.itemCode === "TITLE")
            : []
        );
        setPointMoney2(data.filter((el) => el.itemCode === "OPTION_POINT"));
        setRoundArray2(data.filter((el) => el.itemCode === "OPTION_MULTIPE"));
        const dataCoins = data.filter((el) => el.itemCode === "CONDITION_COIN");
        setCoins(
          dataCoins.map((item) => ({
            ...item,
            value: Number(item?.value),
          }))
        );
      }
    } catch (err) {}
  };

  // dùng switch để render data các thứ trong tuần
  const renderDataForday = (key) => {
    switch (key) {
      case "0":
        return dataSunday;
      case "1":
        return dataMonday;
      case "2":
        return dataTuesday;
      case "3":
        return dataWednesMonday;
      case "4":
        return dataThursday;
      case "5":
        return dataFriday;
      case "6":
        return dataSaturday;
    }
  };

  const handleChange = (value) => {
    setDay(value);
  };

  // hàm này dùng để add form ở dạng view
  const handleAddWeedDayForm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const newData = {
      value: "",
      value1: "",
      value2: "",
      module: "TICKET2",
      item: day,
      itemCode: "TITLE",
    };
    switch (day) {
      case "0":
        return setDataSunday([...dataSunday, newData]);
      case "1":
        return setDataMonday([...dataMonday, newData]);
      case "2":
        return setDataTuesday([...dataTuesday, newData]);
      case "3":
        return setDataWednesday([...dataWednesMonday, newData]);
      case "4":
        return setDataThursday([...dataThursday, newData]);
      case "5":
        return setDataFriday([...dataFriday, newData]);
      case "6":
        return setDataSaturday([...dataSaturday, newData]);
    }
  };

  // hàm này để check add or update giải thưởng
  const handleAddOrUpdatePrize = async (id, idex) => {
    if (
      renderDataForday(day)[idex]?.value === "" ||
      renderDataForday(day)[idex]?.value1 === "" ||
      renderDataForday(day)[idex]?.value2 === ""
    )
      return;
    try {
      const body = {
        module: renderDataForday(day)[idex].module,
        item: day,
        itemCode: renderDataForday(day)[idex].itemCode,
        value: renderDataForday(day)[idex]?.value,
        value1: renderDataForday(day)[idex]?.value1,
        value2: renderDataForday(day)[idex]?.value2,
      };
      if (id) {
        await API.patch(`${COMMON}/${id}`, body);
      } else {
        await API.post(`${COMMON}/create`, body);
        await getDataTicket2();
      }
    } catch (err) {
      console.log(err);
    }
  };

  // hàm này dùng để onchange input form giải thưởng
  const handleChangeInput = (e, index, field) => {
    switch (day) {
      case "0":
        const updateDataSunday = [...dataSunday];
        updateDataSunday[index] = {
          ...updateDataSunday[index],
          [field]: e.target.value,
        };
        return setDataSunday(updateDataSunday);
      case "1":
        const updateDataMonday = [...dataMonday];
        updateDataMonday[index] = {
          ...updateDataMonday[index],
          [field]: e.target.value,
        };
        return setDataMonday(updateDataMonday);
      case "2":
        const updateDataTuesday = [...dataTuesday];
        updateDataTuesday[index] = {
          ...updateDataTuesday[index],
          [field]: e.target.value,
        };
        return setDataTuesday(updateDataTuesday);
      case "3":
        const updateDataWenday = [...dataWednesMonday];
        updateDataWenday[index] = {
          ...updateDataWenday[index],
          [field]: e.target.value,
        };
        return setDataWednesday(updateDataWenday);
      case "4":
        const updatedataThursday = [...dataThursday];
        updatedataThursday[index] = {
          ...updatedataThursday[index],
          [field]: e.target.value,
        };
        return setDataThursday(updatedataThursday);
      case "5":
        const updateDataFriday = [...dataFriday];
        updateDataFriday[index] = {
          ...updateDataFriday[index],
          [field]: e.target.value,
        };
        return setDataFriday(updateDataFriday);
      case "6":
        const updateDataSaturday = [...dataSaturday];
        updateDataSaturday[index] = {
          ...updateDataSaturday[index],
          [field]: e.target.value,
        };
        return setDataThursday(updateDataSaturday);
    }
  };

  // hàm xóa ở view và xóa call api
  const handleDeletePrize = async (id, index) => {
    try {
      if (id) {
        await API.delete(`${COMMON}/${id}`);
        await getDataTicket2();
      } else {
        switch (day) {
          case "0":
            const updateDataSunday = [...dataSunday];
            updateDataSunday.splice(index, 1);
            return setDataSunday(updateDataSunday);
          case "1":
            const updateDataMonday = [...dataMonday];
            updateDataMonday.splice(index, 1);
            return setDataMonday(updateDataMonday);
          case "2":
            const updateDataTuesday = [...dataTuesday];
            updateDataTuesday.splice(index, 1);
            return setDataTuesday(updateDataTuesday);
          case "3":
            const updateDataWenday = [...dataWednesMonday];
            updateDataWenday.splice(index, 1);
            return setDataWednesday(updateDataWenday);
          case "4":
            const updatedataThursday = [...dataThursday];
            updatedataThursday.splice(index, 1);
            return setDataThursday(updatedataThursday);
          case "5":
            const updateDataFriday = [...dataFriday];
            updateDataFriday.splice(index, 1);
            return setDataFriday(updateDataFriday);
          case "6":
            const updateDataSaturday = [...dataSaturday];
            updateDataSaturday.splice(index, 1);
            return setDataSaturday(updateDataSaturday);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  // hàm change input điểm và vòng cược
  const handleChangeInputPointAndRound = (e, index, field, key) => {
    if (key === "point") {
      const updateDataPoint = [...pointMoney2];
      updateDataPoint[index] = {
        ...updateDataPoint[index],
        [field]: e,
      };

      setPointMoney2(updateDataPoint);
    }
    if (key === "round") {
      const updateDataRound = [...roundArray2];
      updateDataRound[index] = {
        ...updateDataRound[index],
        [field]: e,
      };
      setRoundArray2(updateDataRound);
    }
  };

  // hàm thêm data ở view or call api
  const handleAddPointAndRoundTicket2 = async (id, key, field) => {
    if (!id) return;
    const newData = {
      parentId: id,
      value: "1",
      value1: "0",
      module: "TICKET2",
      item: day,
      itemCode: field,
    };
    if (field === "OPTION_POINT") {
      setPointMoney2([...pointMoney2, newData]);
    } else if (field === "OPTION_MULTIPE") {
      setRoundArray2([...roundArray2, newData]);
    }
  };

  // hàm xóa data ở view or call api
  const handleDeletePointAndRound = async (id, index, field) => {
    if (id) {
      try {
        await API.delete(`${COMMON}/${id}`);
        await getDataTicket2();
      } catch (err) {
        console.log(err);
      }
    } else {
      if (field === "point") {
        const updateDataPoint = [...pointMoney2];
        updateDataPoint.splice(index, 1);
        return setPointMoney2(updateDataPoint);
      } else {
        const updateDataRound = [...roundArray2];
        updateDataRound.splice(index, 1);
        return setRoundArray2(updateDataRound);
      }
    }
  };

  // hàm update tổng của vé 2 sao
  const handleUpdateTicket2 = async () => {
    try {
      setIsShowModalConfirm(false);
      setIsShowModalSuccess(true);
      let data = [];

      if (dataMonday.length > 0) {
        dataMonday.forEach((el) => {
          data.push(el);
        });
      }

      if (dataTuesday.length > 0) {
        dataTuesday.forEach((el) => {
          data.push(el);
        });
      }

      if (dataWednesMonday.length > 0) {
        dataWednesMonday.forEach((el) => {
          data.push(el);
        });
      }

      if (dataThursday.length > 0) {
        dataThursday.forEach((el) => {
          data.push(el);
        });
      }

      if (dataFriday.length > 0) {
        dataFriday.forEach((el) => {
          data.push(el);
        });
      }

      if (dataSaturday.length > 0) {
        dataSaturday.forEach((el) => {
          data.push(el);
        });
      }

      if (dataSunday.length > 0) {
        dataSunday.forEach((el) => {
          data.push(el);
        });
      }

      if (pointMoney2.length > 0) {
        pointMoney2.forEach((el) => {
          data.push(el);
        });
      }

      if (roundArray2.length > 0) {
        roundArray2.forEach((el) => {
          data.push(el);
        });
      }

      if (coins.length > 0) {
        coins.forEach((el) => {
          data.push(el);
        });
      }

      const body = {
        sysConfigs: data,
      };

      await API.patch(`${COMMON}/ids`, body);
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const handleChangeCoin = (e, id) => {
    const newData = coins.map((item) =>
      item.id === id ? { ...item, value: e } : item
    );

    setCoins(newData);
  };

  const handleAddOrUpdateCoin = async (id, idDay, index) => {
    if (!idDay) return;
    try {
      setIsPending(true);
      const body = {
        parentId: id ? coins.find((el) => el.id === id).parentId : idDay,
        value: id
          ? coins.find((el) => el.id === id).value.toString()
          : coinLocal[index].value.toString(),
        itemCode: "CONDITION_COIN",
        module: "TICKET2",
        item: day,
      };
      if (id) {
        await API.patch(`${COMMON}/${id}`, body);
        await getDataTicket2();
      } else {
        await API.post(`${COMMON}/create`, body);
        await getDataTicket2();
      }
    } catch (err) {
      setIsPending(false);
      console.log(err);
    } finally {
      setIsPending(false);
    }
  };

  const handleChangeCoinLocal = (e, value, index) => {
    const updateData = [...coinLocal];
    updateData[index] = {
      ...updateData[index],
      value: e,
    };
    setCoinLocal(updateData);
  };

  const handleAddAndUpdatePointdAndround = async (id, idDay, index, field) => {
    try {
      setIsPending(true);
      const body = {
        parentId:
          field === "OPTION_POINT"
            ? pointMoney2[index].parentId
            : roundArray2[index].parentId,
        module: "TICKET2",
        item: day,
        value:
          field === "OPTION_POINT"
            ? pointMoney2[index].value.toString()
            : roundArray2[index].value.toString(),
        value1:
          field === "OPTION_POINT"
            ? pointMoney2[index].value1.toString()
            : roundArray2[index].value1.toString(),
        itemCode: field,
      };
      if (id) {
        await API.patch(`${COMMON}/${id}`, body);
        await getDataTicket2();
      } else {
        await API.post(`${COMMON}/create`, body);
        await getDataTicket2();
      }
    } catch (err) {
      setIsPending(false);
      console.log(err);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="col-12">
      <div className="col-12" style={{ display: "flex", alignItems: "center" }}>
        <div className="col-4">{TEXT_DEF.text0057}:</div>
        <div className="col-8" style={{ display: "flex" }}>
          <Switch
            style={{ marginTop: "5px", width: 80 }}
            checked={maintenanceTicket?.value}
            checkedChildren="Bật"
            unCheckedChildren="Tắt"
            onChange={(e) =>
              setMaintenaceTicket((prev) => ({
                ...prev,
                value: e,
              }))
            }
          />
          <Button
            type="primary"
            onClick={(e) => onShowModal(e, "mainTiket2")}
            style={{
              marginLeft: "2rem",
            }}
          >
            {TEXT_DEF.update}
          </Button>
        </div>
      </div>
      <div className="col-12 mt-5" style={{ display: "flex" }}>
        <div
          className="col-2"
          style={{ display: "flex", alignItems: "center" }}
        >
          Chọn thứ:
        </div>
        <Select
          // defaultValue="1"
          value={day}
          onChange={handleChange}
          style={{ width: 200 }}
          options={DAYS_WEEK}
        />
      </div>

      <div>
        <div
          className="col-12"
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="wrapper" style={{ display: "flex" }}>
            <div className="prize">
              <div className="body-prize" style={{ border: "1px solid" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {renderDataForday(day)?.map((itemDay, index) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          borderBottom: "1px solid",
                        }}
                        key={index}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "40%",
                            marginTop: "2.5rem",
                            marginBottom: "2.5rem",
                            flexDirection: "column",
                          }}
                          key={itemDay.id}
                        >
                          <div style={{ display: "flex" }}>
                            <div className="body-price">
                              <div className="body-row">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    width: "25%",
                                  }}
                                >
                                  {TEXT_DEF.title}:
                                </div>
                                <Input
                                  required
                                  spellCheck="false"
                                  value={itemDay?.value}
                                  style={{ width: "100%", marginLeft: "1rem" }}
                                  onChange={(e) =>
                                    handleChangeInput(e, index, "value")
                                  }
                                />
                              </div>
                              <div className="body-row">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    width: "25%",
                                  }}
                                >
                                  {TEXT_DEF.message_1}:
                                </div>
                                <Input
                                  required
                                  spellCheck="false"
                                  value={itemDay?.value1}
                                  style={{ width: "100%", marginLeft: "1rem" }}
                                  onChange={(e) =>
                                    handleChangeInput(e, index, "value1")
                                  }
                                />
                              </div>
                              <div className="body-row">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    width: "25%",
                                  }}
                                >
                                  {TEXT_DEF.message_2}:
                                </div>
                                <Input
                                  required
                                  spellCheck="false"
                                  value={itemDay?.value2}
                                  style={{ width: "100%", marginLeft: "1rem" }}
                                  onChange={(e) =>
                                    handleChangeInput(e, index, "value2")
                                  }
                                />
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                justifyContent: "space-around",
                              }}
                            >
                              <Button
                                type="danger"
                                onClick={() =>
                                  handleDeletePrize(itemDay.id, index)
                                }
                              >
                                Xóa
                              </Button>
                              <Button
                                type="primary"
                                onClick={() =>
                                  handleAddOrUpdatePrize(itemDay.id, index)
                                }
                              >
                                Lưu
                              </Button>
                            </div>
                          </div>
                        </div>

                        <div
                          className="money-round"
                          style={{ borderLeft: "1px solid", height: "100%" }}
                        >
                          {itemDay.id && (
                            <div className="body-money-round">
                              {/* check điều kiện tổng coin theo ngày dựa vào parentId của giải thưởng */}
                              {coins.find(
                                (el) => el.parentId === itemDay.id
                              ) ? (
                                coins.map((itemCoin) => {
                                  if (itemCoin.parentId === itemDay.id) {
                                    return (
                                      <div
                                        key={itemCoin.id}
                                        style={{
                                          marginTop: "1rem",
                                          width: "100%",
                                          alignItems: "center",
                                          display: "flex",
                                          paddingBottom: "1rem",
                                          borderBottom: "1px solid",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "23%",
                                            display: "flex",
                                            justifyContent: "end",
                                            marginRight: "2rem",
                                          }}
                                        >
                                          {TEXT_DEF.text_coins}:
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            marginRight: "3rem",
                                          }}
                                        >
                                          <InputNumber
                                            type="number"
                                            value={itemCoin?.value}
                                            min={1}
                                            onChange={(e) =>
                                              handleChangeCoin(e, itemCoin.id)
                                            }
                                          />
                                        </div>
                                        <div>
                                          <Button
                                            type="primary"
                                            htmlType="button"
                                            onClick={() =>
                                              handleAddOrUpdateCoin(
                                                itemCoin.id,
                                                itemDay.id,
                                                null
                                              )
                                            }
                                            disabled={isPending}
                                          >
                                            Lưu
                                          </Button>
                                        </div>
                                      </div>
                                    );
                                  }
                                })
                              ) : (
                                <div
                                  style={{
                                    marginTop: "1rem",
                                    width: "100%",
                                    alignItems: "center",
                                    display: "flex",
                                    paddingBottom: "1rem",
                                    borderBottom: "1px solid",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "23%",
                                      display: "flex",
                                      justifyContent: "end",
                                      marginRight: "2rem",
                                    }}
                                  >
                                    {TEXT_DEF.text_coins}:
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      marginRight: "3rem",
                                    }}
                                  >
                                    <InputNumber
                                      value={coinLocal?.value}
                                      onChange={(e) =>
                                        handleChangeCoinLocal(
                                          e,
                                          itemDay.id,
                                          index
                                        )
                                      }
                                      type="number"
                                      min={1}
                                    />
                                  </div>
                                  <div>
                                    <Button
                                      type="primary"
                                      htmlType="button"
                                      onClick={() =>
                                        handleAddOrUpdateCoin(
                                          null,
                                          itemDay.id,
                                          index
                                        )
                                      }
                                    >
                                      Lưu
                                    </Button>
                                  </div>
                                </div>
                              )}
                              <div
                                style={{
                                  borderBottom: "1px solid",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      marginRight: "3rem",
                                      textAlign: "end",
                                      justifyContent: "end",
                                      width: "16%",
                                    }}
                                  >
                                    {TEXT_DEF.precent_prize}:
                                  </div>
                                  <div>
                                    {/* check điểm thưởng render dựa vào parentId của giải thưởng */}
                                    {pointMoney2.map((itemPoint, index) => {
                                      if (itemPoint.parentId === itemDay.id) {
                                        return (
                                          <div
                                            key={index}
                                            style={{
                                              display: "flex",
                                              width: "100%",
                                              marginTop: "1rem",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                width: "70%",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  width: "15rem",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "55%",
                                                    justifyContent: "end",
                                                  }}
                                                >
                                                  {TEXT_DEF.point}:
                                                </div>
                                                <InputNumber
                                                  type="number"
                                                  value={itemPoint?.value}
                                                  min={0}
                                                  defaultValue={0}
                                                  max={9999}
                                                  style={{
                                                    marginLeft: "1rem",
                                                    height: "2rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "60%",
                                                  }}
                                                  onChange={(e) =>
                                                    handleChangeInputPointAndRound(
                                                      e,
                                                      index,
                                                      "value",
                                                      "point"
                                                    )
                                                  }
                                                />
                                              </div>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  marginLeft: "1rem",
                                                }}
                                              >
                                                <div>{TEXT_DEF.percent}:</div>
                                                <InputNumber
                                                  type="number"
                                                  defaultValue={0}
                                                  value={itemPoint?.value1}
                                                  min={0}
                                                  max={9999}
                                                  onChange={(e) =>
                                                    handleChangeInputPointAndRound(
                                                      e,
                                                      index,
                                                      "value1",
                                                      "point"
                                                    )
                                                  }
                                                  style={{
                                                    marginLeft: "1rem",
                                                    height: "2rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "50%",
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div>
                                              <Button
                                                type="danger"
                                                onClick={() =>
                                                  handleDeletePointAndRound(
                                                    itemPoint.id,
                                                    index,
                                                    "point"
                                                  )
                                                }
                                                style={{
                                                  marginRight: "1rem",
                                                  cursor: "pointer",
                                                }}
                                                disabled={isPending}
                                              >
                                                Xóa
                                              </Button>
                                            </div>
                                            <div>
                                              <Button
                                                type="primary"
                                                onClick={() =>
                                                  handleAddAndUpdatePointdAndround(
                                                    itemPoint.id,
                                                    itemDay.id,
                                                    index,
                                                    "OPTION_POINT"
                                                  )
                                                }
                                              >
                                                Lưu
                                              </Button>
                                            </div>
                                          </div>
                                        );
                                      }
                                    })}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    marginTop: "0.2rem",
                                    marginBottom: "0.2rem",
                                    marginLeft: "9rem",
                                  }}
                                >
                                  <Button
                                    type="primary"
                                    onClick={() =>
                                      handleAddPointAndRoundTicket2(
                                        itemDay.id,
                                        itemDay.item,
                                        "OPTION_POINT"
                                      )
                                    }
                                    style={{
                                      marginTop: "0.5rem",
                                      marginBottom: "0.5rem",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Add
                                  </Button>
                                </div>
                              </div>
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      marginRight: "3rem",
                                      textAlign: "end",
                                      justifyContent: "end",
                                      width: "16%",
                                    }}
                                  >
                                    {TEXT_DEF.precent_round}:
                                  </div>
                                  <div>
                                    {/* check vòng cược render dựa vào parentId của giải thưởng */}
                                    {roundArray2.map((itemRound, index) => {
                                      if (itemRound.parentId === itemDay.id) {
                                        return (
                                          <div
                                            key={itemRound.id}
                                            style={{
                                              display: "flex",
                                              width: "100%",
                                              marginTop: "1rem",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                width: "70%",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  width: "15rem",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "55%",
                                                    justifyContent: "end",
                                                  }}
                                                >
                                                  {TEXT_DEF.number_round}:
                                                </div>
                                                <InputNumber
                                                  type="number"
                                                  value={itemRound?.value}
                                                  min={0}
                                                  defaultValue={1}
                                                  max={9999}
                                                  onChange={(e) =>
                                                    handleChangeInputPointAndRound(
                                                      e,
                                                      index,
                                                      "value",
                                                      "round"
                                                    )
                                                  }
                                                  style={{
                                                    marginLeft: "1rem",
                                                    height: "2rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "60%",
                                                  }}
                                                />
                                              </div>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  marginLeft: "1rem",
                                                }}
                                              >
                                                <div>{TEXT_DEF.percent}:</div>
                                                <InputNumber
                                                  type="number"
                                                  value={itemRound?.value1}
                                                  defaultValue={0}
                                                  min={0}
                                                  max={9999}
                                                  style={{
                                                    marginLeft: "1rem",
                                                    height: "2rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "50%",
                                                  }}
                                                  onChange={(e) =>
                                                    handleChangeInputPointAndRound(
                                                      e,
                                                      index,
                                                      "value1",
                                                      "round"
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div>
                                              <Button
                                                type="danger"
                                                onClick={() =>
                                                  handleDeletePointAndRound(
                                                    itemRound.id,
                                                    index,
                                                    "round"
                                                  )
                                                }
                                                style={{
                                                  marginRight: "1rem",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                Xóa
                                              </Button>
                                            </div>
                                            <div>
                                              <Button
                                                type="primary"
                                                onClick={() =>
                                                  handleAddAndUpdatePointdAndround(
                                                    itemRound.id,
                                                    itemDay.id,
                                                    index,
                                                    "OPTION_MULTIPE"
                                                  )
                                                }
                                              >
                                                Lưu
                                              </Button>
                                            </div>
                                          </div>
                                        );
                                      }
                                    })}
                                  </div>
                                </div>

                                <div
                                  style={{
                                    marginTop: "0.5rem",
                                    marginBottom: "0.5rem",
                                    marginLeft: "9rem",
                                  }}
                                >
                                  <Button
                                    type="primary"
                                    onClick={() =>
                                      handleAddPointAndRoundTicket2(
                                        itemDay.id,
                                        itemDay.item,
                                        "OPTION_MULTIPE"
                                      )
                                    }
                                    style={{
                                      marginTop: "0.5rem",
                                      marginBottom: "0.5rem",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Add
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "2rem",
                      alignItems: "center",
                      marginRight: "1rem",
                      height: "100%",
                      padding: "1rem 0",
                    }}
                  >
                    <Button
                      type="primary"
                      onClick={(e) => handleAddWeedDayForm(e)}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-12 mt-5"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          htmlType="button"
          type="primary"
          onClick={(e) => setIsShowModalConfirm(true)}
        >
          {TEXT_DEF.update}
        </Button>
      </div>
      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0062}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={handleUpdateTicket2}
          close={() => setIsShowModalConfirm(false)}
        />
      )}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0063}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => {
            setIsShowModalSuccess(false);
          }}
          close={() => {
            setIsShowModalSuccess(false);
          }}
        />
      )}
    </div>
  );
};

export default TicketTow;
